import React from 'react';

const NotFound = () => {
  return <div>This page doesn't exist</div>;
};

export default NotFound;
